import { BooleanValueProperty } from './properties/boolean-property.model';
import { ImageProperty } from './properties/image-property.model';
import { TextProperty } from './properties/text-property.model';
import { Widget } from './form-widget.model';

export class FbBeforeAfterGalleriesWidget extends Widget {
  public override title = 'Before After';
  public override name = 'cb-beforeafter-galleries';

  constructor(data: any = {}) {
    super();

    this.properties = this.defaultProperties(data.properties);
  }

  defaultProperties(props: any = {}) {
    const properties = {
      text: new TextProperty({ value: props.text ? props.text.value : 'Label 1' }),
      procedure: new TextProperty({ value: props.procedure ? props.procedure.value : 0 }),
      gallery: new TextProperty({ value: props.gallery ? props.gallery.value : 0 }),
      hideLabel: new BooleanValueProperty({
        value: props.hideLabel ? props.hideLabel.value : false,
      }),
    };
    return properties;
  }
}
